import { useNavigate } from 'react-router-dom'
import { TrialSuccess } from '../../Common/TrialSuccess'
import { APPS_PAGE_PATH } from '../../../CustomIntegration/constants'

export const CustomIntegrationSuccess: React.FC = () => {
  const navigate = useNavigate()

  return <TrialSuccess buttonLabel='Go to Apps' onButtonClick={() => navigate(APPS_PAGE_PATH)} />
}
